// ユーザー画面（fronts レイアウト）の Turbo・Stimulus とその controller（#2311 C-2）。
// 以前は importmap（javascript_importmap_tags）で読んでいた。管理画面は今も importmap で読む。
// fronts.haml の <head> から defer 付きのクラシック <script>（IIFE）で読む。body 末尾の同期 script
// （application-esbuild・Stripe）の後、DOMContentLoaded の前に実行される。
import '@hotwired/turbo-rails'
import * as ActiveStorage from '@rails/activestorage'
import { Application } from '@hotwired/stimulus'

import AccordionPanelController from '../app/javascript/controllers/accordion_panel_controller'
import CarouselController from '../app/javascript/controllers/carousel_controller'
import ConfirmReservationController from '../app/javascript/controllers/confirm_reservation_controller'
import CopyTooltipController from '../app/javascript/controllers/copy_tooltip_controller'
import DateRangePickerController from '../app/javascript/controllers/date_range_picker_controller'
import DateSelectionController from '../app/javascript/controllers/date_selection_controller'
import DrawerController from '../app/javascript/controllers/drawer_controller'
import DropdownController from '../app/javascript/controllers/dropdown_controller'
import GalleryController from '../app/javascript/controllers/gallery_controller'
import ModalController from '../app/javascript/controllers/modal_controller'
import MypageFormChildrenController from '../app/javascript/controllers/mypage/form/children_controller'
import MypageFormFamilyController from '../app/javascript/controllers/mypage/form/family_controller'
import MypageFormMeetingTimeDisplayController from '../app/javascript/controllers/mypage/form/meeting_time_display_controller'
import MypageFormNurseryMeetingController from '../app/javascript/controllers/mypage/form/nursery_meeting_controller'
import MypageFormQuestionnaireController from '../app/javascript/controllers/mypage/form/questionnaire_controller'
import MypageFormReviewController from '../app/javascript/controllers/mypage/form/review_controller'
import MypageFormTodoUploadsController from '../app/javascript/controllers/mypage/form/todo_uploads_controller'
import MypageModalController from '../app/javascript/controllers/mypage/modal_controller'
import MypageReviewFormModalController from '../app/javascript/controllers/mypage/review_form_modal_controller'
import NewReservationController from '../app/javascript/controllers/new_reservation_controller'
import PeopleSelectionController from '../app/javascript/controllers/people_selection_controller'
import ReferralCodeController from '../app/javascript/controllers/referral_code_controller'
import RelationshipOtherToggleController from '../app/javascript/controllers/relationship_other_toggle_controller'
import TotalPriceController from '../app/javascript/controllers/total_price_controller'

declare global {
  interface Window {
    Stimulus: Application
  }
}

ActiveStorage.start()

const application = Application.start()
application.debug = false
// spec/support/searchable_filter_helper.rb などが使う（importmap 版の app/javascript/controllers/application.js と同じ）
window.Stimulus = application

// ユーザー側の view（app/views/ から管理側を除く）の data-controller が使う controller。
// 足し忘れるとエラーなく動かないので、spec/views/hotwire_controllers_spec.rb が view と突き合わせている。
// 登録は router の開始（Application.start() の中の await の後）より前に済むので、connect は view の書き順になる
// （importmap 版の Turbo 遷移の後と同じ。total-price が date-range-picker より先に connect する）。
application.register('accordion-panel', AccordionPanelController)
application.register('carousel', CarouselController)
application.register('confirm-reservation', ConfirmReservationController)
application.register('copy-tooltip', CopyTooltipController)
application.register('date-range-picker', DateRangePickerController)
application.register('date-selection', DateSelectionController)
application.register('drawer', DrawerController)
application.register('dropdown', DropdownController)
application.register('gallery', GalleryController)
application.register('modal', ModalController)
application.register('mypage--form--children', MypageFormChildrenController)
application.register('mypage--form--family', MypageFormFamilyController)
application.register('mypage--form--meeting-time-display', MypageFormMeetingTimeDisplayController)
application.register('mypage--form--nursery-meeting', MypageFormNurseryMeetingController)
application.register('mypage--form--questionnaire', MypageFormQuestionnaireController)
application.register('mypage--form--review', MypageFormReviewController)
application.register('mypage--form--todo-uploads', MypageFormTodoUploadsController)
application.register('mypage--modal', MypageModalController)
application.register('mypage--review-form-modal', MypageReviewFormModalController)
application.register('new-reservation', NewReservationController)
application.register('people-selection', PeopleSelectionController)
application.register('referral-code', ReferralCodeController)
application.register('relationship-other-toggle', RelationshipOtherToggleController)
application.register('total-price', TotalPriceController)
